import React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { connect } from "react-redux";
import { GiftCard } from "../../../../types/gift-card";
import NoContentMessage from "../../../common/NoContentMessage";
import BackButton from "../../../common/BackButton";
import ListGiftCards from "../../../common/ListGiftCards";
import { CARD_TYPE } from "../../../../types/card-type";
import { getEnabledCardTypes, getWalletCardTypesImages } from "../../../../reducers/user/wallet-cards";

type Props = RouteComponentProps & {
    enabledCardTypes: string[];
    images: { [key: string]: string };
};

const UserWalletBuy: React.FC<Props> = ({ history, enabledCardTypes, images }) => {
    const imageFolder = "/assets/img/card-types";
    const giftCards: GiftCard[] = [
        {
            id: 1,
            image: images[CARD_TYPE.MOVIECARD] || `${imageFolder}/${CARD_TYPE.MOVIECARD}.png`,
            type: CARD_TYPE.MOVIECARD,
            cardNumber: '',
        },
        {
            id: 2,
            image: images[CARD_TYPE.CINEFAN] || `${imageFolder}/${CARD_TYPE.CINEFAN}.png`,
            type: CARD_TYPE.CINEFAN,
            cardNumber: '',
        },
        {
            id: 3,
            image: images[CARD_TYPE.TICKETCARD] || `${imageFolder}/${CARD_TYPE.TICKETCARD}.png`,
            type: CARD_TYPE.TICKETCARD,
            cardNumber: '',
        },
    ].filter(card => enabledCardTypes.includes(card.type));

    const handleSelectGiftCard = (giftCard: GiftCard) => {
        history.push(`/usuario/wallet/comprar/${giftCard.type}`);
    };

    return (
        <>
            <BackButton backTo="/usuario/wallet" label="Comprar tarjetas" />
            <p className="my-5">
                Conoce las opciones que cada una de las tarjetas tiene para ti.
            </p>
            {giftCards.length ? (
                <ListGiftCards
                    giftCards={giftCards}
                    onSelectGiftCard={giftCard => handleSelectGiftCard(giftCard as GiftCard)}
                    className="my-5"
                />
            ) : (
                <NoContentMessage
                    icon="fa-light fa-credit-card"
                    title="No hay tarjetas disponibles"
                    style={{ maxWidth: "37.5rem" }}
                >
                    <p>Proximamente podrás adquirir tarjetas</p>
                </NoContentMessage>
            )}
        </>
    );
};

const mapStateToProps = (state: any) => ({
    enabledCardTypes: getEnabledCardTypes(state),
    images: getWalletCardTypesImages(state),
});
const mapDispatchToProps = (dispatch: any) => ({});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(UserWalletBuy));